/**
 * Enum for order notify from types.
 * @readonly
 * @enum {String} OrderNotifyFromEnum
 */

const OrderNotifyFromEnum = {
  ORDER_DETAILS     : 'order_details',
  DELIVERY_DASHBOARD: 'delivery_dashboard'
}

export default OrderNotifyFromEnum
